var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\">\n<h3 class=\"modal-title\" id=\"modal-title\">\nAdd Cluster\n</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div>\n<form name=\"ciForm\">\n<div class=\"form-group\">\n<label>Cluster Address: </label>\n<input type=\"text\" ng-model=\"formData.cluster_connection\" class=\"form-control\" placeholder=\"example > http://127.0.0.1:9200\" required>\n</div>\n</form>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" ng-disabled=\"!ciForm.$valid\" type=\"button\" ng-click=\"save()\">Save</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancel</button>\n</div>";
var id1="components/clusters/add-cluster-modal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/clusters/add-cluster-modal.html
// module id = 838
// module chunks = 0